<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="`Delete Resource -- ${resource.name}`"
    :reset-modal="resetModal"
    :submit-button-text="'DELETE'"
    :submit-modal="deleteResource"
  >
    <b-row>
      <b-col>
        <p class="tsny_text">
          This action will delete {{ resource.name }}. Please be absolutely
          certain you want to do this -- this action cannot be undone.
        </p></b-col
      >
    </b-row>
    <b-row>
      <b-col
        ><p class="tsny_status-text" v-if="deleteResourceError">
          An error occurred deleting {{ resource.name }}
        </p></b-col
      >
    </b-row>
  </tsny-modal>
</template>

<script>
import TsnyModal from "../TsnyModal";
import CourseRestService from "../../services/rest/services/CourseRestService";

export default {
  name: "DeleteResourceModal",
  components: { TsnyModal },
  props: {
    courseId: {
      type: String,
      default: null
    },
    resourceIndex: {
      type: Number,
      default: null
    },
    resources: {
      type: Array,
      default: null
    }
  },
  computed: {
    resource: function() {
      return (this.resources || [])[this.resourceIndex || 0] || {};
    }
  },
  data: function() {
    return {
      modalId: "deleteResourceModal",
      deleteResourceError: null
    };
  },
  methods: {
    resetModal: function() {
      this.deleteResourceError = null;
    },
    deleteResource: function(bvModalEvt) {
      bvModalEvt.preventDefault();

      let $comp = this;
      $comp.deleteResourceError = false;

      return CourseRestService.deleteResource(
        $comp.courseId,
        $comp.resource._id
      )
        .then(() => {
          $comp.resources.splice($comp.resourceIndex, 1);
          $comp.$bvModal.hide($comp.modalId);
        })
        .catch(err => {
          console.log(err);
          $comp.deleteResourceError = true;
        });
    }
  }
};
</script>

<style scoped></style>
